<template>
  <div>
    <div class="text-center">
      <pb-icon class="fas fa-exclamation-circle fa-2x" />
    </div>
    <div class="text-center">
      <p>Não foi possível carregar o módulo.</p>
      <p>Verifique sua conexão e tente novamente mais tarde!</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorModule',
  mounted() {
    brain.setVisibilityCloseScript(true);
    brain.connectionError({ message: "Couldn't open module." });
  },
};
</script>

<style lang="scss" scoped>
</style>
